import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import AssignPhoneNumberDialog, {
  AssignPhoneNumberDialogCallbackInput,
  AssignPhoneNumberUniqueProps,
} from '../AssignPhoneNumberDialog';

const { useDialogForContext, useDialog: useAssignPhoneNumberDialog } =
  getDialogHooks<
    AssignPhoneNumberUniqueProps,
    AssignPhoneNumberDialogCallbackInput
  >(AssignPhoneNumberDialog);
export const useAssignPhoneNumberDialogForContext = useDialogForContext;
export default useAssignPhoneNumberDialog;
